import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import ProfileBasicAdvisorInfo from '@/components/profile/advisor/ProfileBasicAdvisorInfo';
import ProfileActions from '@/components/profile/ProfileActions';
import ProfileBasicStaffInfo from '@/components/profile/staff/ProfileBasicStaffInfo';
import { ROUTES } from '@/constants/routes';
import { useGetUser } from '@/hooks/requests/useUser';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { Card, Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ProfileDetails() {
  const { isStaff } = useAuthUser();
  const navigate = useNavigate();
  const { user, isPending } = useGetUser();

  if (isPending) {
    <DefaultLayout header="Profile">
      <Card>
        <SVLoader />
      </Card>
    </DefaultLayout>;
  }

  if (!user) {
    return (
      <DefaultLayout header="Profile">
        <Card>
          <Typography>
            Something went wrong retreiving your user information. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header="Profile"
      buttons={[
        <SVButton
          fullWidth
          key="edit"
          onClick={() => navigate(ROUTES.PROFILE_EDIT)}>
          Edit
        </SVButton>,
      ]}>
      <Stack spacing={2}>
        {isStaff ? (
          <ProfileBasicStaffInfo user={user} />
        ) : (
          <ProfileBasicAdvisorInfo user={user} />
        )}
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}></Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ProfileActions />
          </Grid>
        </Grid>
      </Stack>
    </DefaultLayout>
  );
}
